<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'AfterActivation',
    data() {
      return {
      }
    },

    mounted() {
      //http://localhost:8080/vue/?formId=71018&agentId=370981&openmktCd=2
    },

    created() {

    },
    computed: {
    },

    methods: {
    }
  }
</script>

<style>

</style>
